import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'history-alarms',
  templateUrl: './history-alarms.component.html',
  styleUrls: ['./history-alarms.component.scss']
})
export class HistoryAlarmsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
